export { default as CombinedReport } from './CombinedReport';

/** The reporting leaf's `metric` value: `/campaigns/:id/reporting?state=~(metric~'combined)`. */
export const COMBINED_REPORT_METRIC = 'combined';
